export interface RuneSelection {
  start: number
  end: number
  selectedText: string
}

function runeIndexOf(haystack: string[], needle: string[], from = 0): number {
  if (needle.length === 0 || needle.length > haystack.length) return -1
  for (let i = Math.max(0, from); i <= haystack.length - needle.length; i += 1) {
    let matched = true
    for (let j = 0; j < needle.length; j += 1) {
      if (haystack[i + j] !== needle[j]) {
        matched = false
        break
      }
    }
    if (matched) return i
  }
  return -1
}

export function findRuneSelection(content: string, selectedText: string, fromRune = 0): RuneSelection | null {
  const selected = selectedText.trim()
  if (!content || !selected) return null

  const contentRunes = Array.from(content)
  const selectedRunes = Array.from(selected)
  const start = runeIndexOf(contentRunes, selectedRunes, fromRune)
  if (start < 0) return null

  return {
    start,
    end: start + selectedRunes.length,
    selectedText: selectedRunes.join(''),
  }
}

export function findRuneSelectionNear(content: string, selectedText: string, preferredRune: number): RuneSelection | null {
  const selected = selectedText.trim()
  if (!content || !selected) return null

  const contentRunes = Array.from(content)
  const selectedRunes = Array.from(selected)
  const exact = runeIndexOf(contentRunes, selectedRunes, preferredRune)
  if (exact >= 0) {
    return { start: exact, end: exact + selectedRunes.length, selectedText: selectedRunes.join('') }
  }

  let best = -1
  for (let start = runeIndexOf(contentRunes, selectedRunes, 0); start >= 0; start = runeIndexOf(contentRunes, selectedRunes, start + 1)) {
    if (best < 0 || Math.abs(start - preferredRune) < Math.abs(best - preferredRune)) best = start
  }

  if (best < 0) return null
  return { start: best, end: best + selectedRunes.length, selectedText: selectedRunes.join('') }
}

export function runeCount(value: string | null | undefined): number {
  return Array.from(value ?? '').length
}
